import { render, staticRenderFns } from "./CreateFacturacionCliente.vue?vue&type=template&id=b5dc7d12"
import script from "./CreateFacturacionCliente.vue?vue&type=script&lang=js"
export * from "./CreateFacturacionCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports